<template>
  <van-swipe :autoplay="3000" lazy-render>
    <van-swipe-item v-for="image in banners" :key="image">
      <img class="banner-img" @click="toLink(image)" :src="image.url" />
    </van-swipe-item>
  </van-swipe>
  <div class="company-title">艺龙酒店科技品牌专栏</div>
  <div v-if="brandList && brandList.length" class="brand-matrix-section">
    <div class="matrix-table">
      <div v-for="(row, rowIndex) in brandList"
        :key="row.label"
        :class="['matrix-table-row', { 'even-row': rowIndex % 2 === 0, 'is-last-row': rowIndex === brandList.length - 1 }]">
        <div class="matrix-cell matrix-grade-label">
          {{ row.label }}
        </div>
        <div class="matrix-cell matrix-brand-cell">
          <div class="matrix-logos">
            <img 
              v-for="brand in row.brands.filter(item => item.logo)"
              :key="brand.id"
              :src="brand.logo"
              @click="goDetail(brand.id)"
              class="matrix-logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="company-title">入驻艺龙酒店科技平台公司</div>
  <div class="hotel-company">酒管公司</div>
  <ul class="company-box">
    <li
      @click="toHotlePage(item)"
      v-for="(item, index) in companyList"
      :key="index"
    >
      <img :src="item.logoUrl" />
    </li>
  </ul>
  <div style="margin-top: 30rem" class="hotel-company">赋能平台</div>
  <ul class="company-box">
    <li
      @click="toAssignPlatPage(item)"
      v-for="(item, index) in assignPlats.filter((item) => item.id !== 1)"
      :key="index"
    >
      <img :src="item.logoUrl" />
    </li>
  </ul>
  <div style="margin-top: 30rem" class="hotel-company">会员体系</div>
  <ul class="company-box">
    <li
      v-for="(item, index) in assignPlats.filter((item) => item.id === 1)"
      :key="index"
      @click="toAssignPlatPage(item)"
      class="hide-line"
    >
      <img :src="item.logoUrl" />
    </li>
  </ul>
  <img
    class="company-advantage-img"
    :src="require('@/assets/img/公司优势.jpg')"
  />
  <div v-if="newList && newList.length" class="brand-news">
    <div class="en">NEWS CENTER</div>
    <div class="ch">品牌资讯</div>
  </div>
  <div v-if="newList && newList.length" class="news-wrap">
    <brandNews :newList="newList" />
  </div>
  <appFooter />
</template>

<script setup>
import { ref , onMounted } from "vue";
import { getIndexPageData,getBrandArchiveSpecialByApp } from "@/api/index";
// import { onMounted } from "@vue/runtime-core";
import brandNews from "@/components/brandNew.vue";
import { useRouter } from "vue-router";
import appFooter from "@/components/footer.vue";
import { trackEvent } from "@/utils/tracklog.js";

const banners = ref([]);
const newList = ref([]);
const companyList = ref([]);
const assignPlats = ref([]);
const router = useRouter();
const brandList = ref([]);
onMounted(() => {
  console.log('🍤 onMounted');
  getBrandArchiveSpecialByApp().then((res)=>{
    console.log("🐙 res", res);
    brandList.value = res;
  })
  getIndexPageData().then((data) => {
    const { indexVos, companyVos, enableCompanyConfigVos, infoContentVos } =
      data;
    banners.value = indexVos;
    newList.value = infoContentVos;
    companyList.value = companyVos;
    assignPlats.value = enableCompanyConfigVos;
  });
  trackEvent("浏览页面", "浏览", "浏览页面-首页", {}, 0, new Date().getTime());
});

const toLink = (item) => {
  if (!item.link) {
    return;
  }
  const url = item.link.split("#")[1];
  const baseUrl = window.location.href.split("#")[0];
  window.open(`${baseUrl}#${url}`);
};

const toHotlePage = (item) => {
  // 埋点 酒管公司
  trackEvent(
    "首页-酒管公司",
    "点击",
    "首页-酒管公司",
    { path: `/hotel/${item.id}?companyId=${item.companyId}` },
    0,
    new Date().getTime()
  );
  router.push(`/hotel/${item.id}`);
};
const toAssignPlatPage = (item) => {
  // 埋点 业务中台
  trackEvent(
    `首页-${item.id !== 1 ? "业务中台" : "会员体系"}`,
    "点击",
    `首页-${item.id !== 1 ? "业务中台" : "会员体系"}`,
    {
      path: `${item.id !== 1 ? "/assignPlatform/" : "/elongUnit/"}${item.id}`,
    },
    0,
    new Date().getTime()
  );
  if (item.id !== 1) {
    router.push(`/assignPlatform/${item.id}`);
    return;
  }
  router.push(`/elongUnit/${item.id}`);
};
const goDetail = (id)=>{
 router.push(`/brandColumn/${id}`);
}
</script>

<style lang="scss" scoped>
.banner-img {
  width: 750rem;
}
.company-title {
  font-size: $font-size-large-x;
  text-align: center;
  margin: 40rem 0;
}
.hotel-company {
  color: #005352;
  text-align: center;
  margin-bottom: 24rem;
  font-size: 30rem;
}
.company-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  li {
    width: 187.5rem;
    display: flex;
    justify-content: center;
    margin-bottom: 20rem;
    position: relative;
    &:not(:nth-child(4n)) {
      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1rem;
        height: 80rem;
        background: $color-border;
      }
    }
    &.hide-line {
      &::after {
        background: none;
      }
    }
    img {
      width: 128rem;
      height: 128rem;
    }
  }
}
.company-advantage-img {
  width: 750rem;
}
.brand-news {
  position: relative;
  margin: 48rem auto 42rem;
  width: fit-content;
  .en {
    font-size: $font-size-large-x;
    color: #eee;
  }
  .ch {
    font-size: $font-size-large-x;
    position: absolute;
    top: 46%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }
}
.brand-matrix-section {
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.matrix-table {
  display: table;
  min-width: 100%;
  width: max-content;
  table-layout: auto;
}

.matrix-table-row {
  display: table-row;
  
  &.even-row {
    background: #fcfcfc;
    
  }
}

.matrix-cell {
  display: table-cell;
  position: relative;
  vertical-align: middle;
  text-align: center;
  padding: 16px 25px;
  height: 70px;
}

.matrix-label-header {
  width: 20vw;
}

.matrix-style-header {
  color: #005445;
  font-size: 20px;
  font-family: 'Noto Serif SC', serif;
}
.matrix-style-header:not(:last-child),
.matrix-brand-cell:not(:last-child) {
  position: relative;
}

.matrix-grade-label {
  min-width: 80px;
  width: 80px;
  color: #005445;
  font-size: $font-size-large-x;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  padding: 16px 8px;
  font-family: 'Noto Serif SC', serif;
  position: sticky;
  left: 0;
  z-index: 2;
}

.matrix-table-row {
  &.even-row .matrix-grade-label {
    background: #fcfcfc;
  }
  
  &:not(.even-row) .matrix-grade-label {
    background: #fff;
  }
}


.matrix-brand-cell {
  min-width: 200px;
  padding: 16px 20px;
}

.matrix-logos {
  display: flex;
  gap: 10px;
  align-items: center;
  white-space: nowrap;
}
.matrix-logo {
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  margin: 0;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }
}


.matrix-footer {
  text-align: center;
  color: #000;
  font-size: 15px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: none;
}
</style>